import { state } from '@angular/animations';
import {createReducer, on} from '@ngrx/store';
import { UserMeOutput } from 'src/app/models/users.model';
import {genericActions} from './action-types';
import {Client, ClientUserOutput} from "../../models/client.model";
import { Module } from 'src/app/models/module.model';
import { Action } from 'rxjs/internal/scheduler/Action';
// import {EmployeeDto} from '../../shared/models/employee.models';
// import {Client} from '../../shared/models/client';
// import {CompanyOutputDto} from '../../shared/models/company.models';





export interface GeneralState {

  profile: UserMeOutput | undefined;
  isLoading: boolean;
  client: ClientUserOutput | undefined;
  myPoints: number | undefined;
  modules: Module[] | undefined;
}

export const initialState: GeneralState = {
  profile: undefined,
  isLoading: false,
  client: undefined,
  myPoints: undefined,
  modules: undefined
};

export const generalReducer = createReducer(
  initialState,
  on(genericActions.loadingStart, (state) => ({...state, isLoading: true,})),
  on(genericActions.loadingEnd, (state) => ({ ...state, isLoading: false })),
  on(genericActions.loadingProfile, (state) => ({...state, isLoading: true, profile: undefined})),
  on(genericActions.loadedProfile, (state, action) => {
    return {
      ...state,
      profile: action.profile,
      isLoading: false,
      // profileDipendenteCompleted: action.employee ? isEmployeeProfileCompleted(action.employee) : false,
      // profileCompletedToOfferPass: action.employee ? isEmployeeProfileCompletedToOfferPass(action.employee) : false,
    };
  }),
  on(genericActions.loadingProfileFailed, (state) => ({...state, isLoading: false, profile: undefined})),
  on(genericActions.updatingProfile, (state) => ({ ...state, isLoading: true })),
  on(genericActions.updatedProfile, (state, props) => ({ ...state, isLoading: false, profile: props.profile })),
  on(genericActions.updatingProfileFailed, (state) => ({ ...state, isLoading: false, profile: undefined })),

  on(genericActions.updatingAvatar, (state) => ({...state, isLoading: true, profile:  state.profile ? {...state.profile, avatar: undefined} : undefined})),
  on(genericActions.updatedAvatar, (state, props) => ({ ...state, isLoading: false, profile: state.profile? {...state.profile, avatar: props.avatar} : undefined})),
  on(genericActions.updatingAvatarFailed, (state) => ({...state, isLoading: false})),



  on(genericActions.loadingClient, (state) => ({...state, isLoading: true})),
  on(genericActions.loadClientCompleted, (state, action) => ({...state, isLoading: false, client: action.client})),
  on(genericActions.loadClientFailed, (state) => ({...state, isLoading: false, client: undefined})),

  on(genericActions.loadingModules, (state) => ({...state, isLoading: true})),
  on(genericActions.loadedModules, (state, action) => ({...state, isLoading: false, modules: action.modules})),
  on(genericActions.loadingModulesFailed, (state) => ({...state, isLoading: false, modules: undefined})),

  on(genericActions.loadingMyPoints, (state) => ({...state, isLoading: true})),
  on(genericActions.loadedMyPoints, (state, action) => ({...state, isLoading: false, myPoints: action.myPoints})),
  on(genericActions.loadingMyPointsFailed, (state) => ({...state, isLoading: false, myPoints: undefined})),

  // on(genericActions.deactivatingUser, (state) => ({...state})),
  // on(genericActions.deactivateUser, (state) => ({...state, deactivateRequest: true})),
  // on(genericActions.deactivatingUserFailed, (state) => ({...state, deactivateRequest: false}))
);




